<template>
  <v-dialog :value="visible" max-width="650px" @input="$emit('update:visible', $event)">
    <v-card class="pa-sm-10 pa-3">
      <v-card-title v-t="'hardDeleteCorrection'" class="justify-center text-h5" />
      <v-card-text>
        <v-row>
          <v-col v-t="'hardDeleteCorrectionConfirm'" cols="12" class="d-flex align-center justify-center text-center" />
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center mt-3">
            <v-btn v-t="'discard'" outlined class="me-3" :disabled="loading" @click="$emit('discard')" />
            <v-btn :loading="loading" color="error" @click="$emit('confirm')">{{ $t('delete') }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
